export default[
    {//分享
        path: '/share',
        component: function (resolve) {
            require(['./Share.vue'], resolve);
        },
        children:[
            {
                path: 'doc',
                name:"doc",
                component: function (resolve) {
                    require(['./Doc.vue'], resolve);
                }
            },
            {
                path: 'member',
                name:"member",
                component: function (resolve) {
                    require(['./Member.vue'], resolve);
                }
            },
        ]
    }
]